/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MoveStudentsRequestSourceCourseIds } from './moveStudentsRequestSourceCourseIds';
import type { MoveStudentsRequestAccessibleModuleIds } from './moveStudentsRequestAccessibleModuleIds';

/**
 * Request model for moving students between courses
 */
export interface MoveStudentsRequest {
  targetCourseId: string;
  studentIds: string[];
  sourceCourseIds?: MoveStudentsRequestSourceCourseIds;
  accessibleModuleIds?: MoveStudentsRequestAccessibleModuleIds;
}
